define('gameday-device-interaction/lib/DeviceInteraction',['require','exports','module','es6ish-class/es6ish-class','jquery'],function(require,exports,module){
    var classinator = require( "es6ish-class/es6ish-class" ),
        $           = require( "jquery" );

    var noop = function(){},
        switchboard = $('body',document),
        namespace = ".deviceInteraction",
        INTERACTION = "click" + namespace;

    function DeviceInteraction(){
        // Make sure calls don't fail if we don't have a valid dispatcher
        return this.dispatcher ? this : new DeviceInteraction();
    };

    DeviceInteraction.isDispatcherAvailable = false;
    DeviceInteraction.prototype={
        listen      : function(selectorMap,scope){
            selectorMap = selectorMap || {};
            scope = $(scope) || switchboard;
            var di = this,
                method,
                type;

            for(type in selectorMap){
                if(selectorMap.hasOwnProperty(type) && (type in di)){
                    method = di[type];
                    scope.off(INTERACTION).on(INTERACTION, selectorMap[type], function(e){
                        e.stopPropagation();
                        e.preventDefault();
                        method.call(di,$(this).data());
                    });
                }
            }
        },
        dispatcher  : noop,
        close       : noop,
        track       : noop,
        video       : noop,
        webview     : noop,
        navigate    : noop,
        paywall     : noop,
        hasAccess   : noop,
        playercard  : noop,
        mlbtv       : noop,
        share       : noop
    };

    classinator(DeviceInteraction);

    return  DeviceInteraction;
});
